import React, { Component } from "react";

import {Button} from '@learningblocks/exp-components';
//import { PDFDownloadLink } from "@react-pdf/renderer";
//import { PdfDocument } from "../../../../../../NotebookContent/ContentFooter/Report/Report";

import "./EndSimulation.scss";

//import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";
import warningIcon from "./img/warning-modal-icon.svg";

export class EndSimulation extends Component {

  endSimulation = () => {

    this.props.showModal(false);

    window.parent.postMessage({
      method: 'event',
      data: {type: 'requestClose'}
    }, '*');

    return false;
  };

  render() {
    return (
      <div className="modal-section endSimulationModal">
        <img alt="Warning icon." src={warningIcon} className="warningIcon" />
        <h3 className="heading">
          End Simulation
        </h3>
        {/*<p className="endDescription">Are you sure you want to end this simulation without dowloading your report? You won’t be able to do this later.</p>*/}
        <p className="endDescription">Are you sure you want to end this simulation?</p>
        <div className="modal-footer">
          <Button className='endSimulation' onClick={this.endSimulation}>
           End Simulation
          </Button>
          {/*<Button className='downloadReport'>
            <PDFDownloadLink
              style={{textDecoration: "none", color: "#333333"}}
              document={<PdfDocument />}
              fileName="PCR_Protocol_Sim_Report.pdf"
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading document..." : "Download report"
              }
            </PDFDownloadLink>
          </Button>*/}
        </div>
      </div>
    );
  }
}
